import type { ChatPascoDTO } from '../dto/chat.dto';

/**
 * Chat PASCO Mapper
 * Maps between WebSocket DTOs and domain/UI models
 */
export class ChatPascoMapper {
    /**
     * Extract PASCO IDs from chat response
     */
    static toPascoIds(mostRelevant: ChatPascoDTO[], leastRelevant: ChatPascoDTO[]): string[] {
        return [...mostRelevant, ...leastRelevant].map((pasco) => pasco.pasco_id);
    }

    /**
     * Map to display format for UI
     */
    static toDisplayPascos(pascos: ChatPascoDTO[]): Array<{
        pascoId: string;
        courseCode: string;
        courseName: string;
        academicYear: string;
        semester: number;
        department?: string;
        level: number;
        isInterimAssessment: boolean;
    }> {
        return pascos.map((pasco) => ({
            pascoId: pasco.pasco_id,
            courseCode: pasco.course_code,
            courseName: pasco.course_name,
            academicYear: pasco.academic_year,
            semester: pasco.semester,
            department: pasco.department,
            level: pasco.level || 0,
            isInterimAssessment: pasco.is_interim_assessment,
        }));
    }
}
